/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetAodScheduledRunsScheduledRunsForRuleQueryResponse, GetAodScheduledRunsScheduledRunsForRulePathParams, GetAodScheduledRunsScheduledRunsForRule404 } from "../models/GetAodScheduledRunsScheduledRunsForRule";

export function getGetAodScheduledRunsScheduledRunsForRuleUrl(ruleId: GetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"]) {
  const res = { method: 'GET', url: `/aod-runs/scheduled/rules/${ruleId}` as const }
  return res
}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule
 * @summary Get scheduled runs for an AOD rule
 * {@link /aod-runs/scheduled/rules/:ruleId}
 */
export async function getAodScheduledRunsScheduledRunsForRule(ruleId: GetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<GetAodScheduledRunsScheduledRunsForRule404>, unknown>({ method : "GET", url : getGetAodScheduledRunsScheduledRunsForRuleUrl(ruleId).url.toString(), ... requestConfig })
  return res.data
}